const intervalId = setInterval(function() {
  if (document.querySelectorAll('#ai-size-popup').length > 0) {
    clearInterval(intervalId);
 
    const popupContainer = document.querySelector('#ai-size-popup');
    const sizeBtnContainer = document.querySelector('.ai-size-button-container');
 
    const sizeGuideBtn = document.createElement('button');
    sizeGuideBtn.className = 'btn-size-guide';
    sizeGuideBtn.textContent = 'Size Guide';
 
    const observer = new MutationObserver((mutations, obs) => {
      const sizeBtn = document.querySelector(".ai-size-button");
      if (sizeBtn && sizeBtn.hasAttribute("style")) {
        sizeGuideBtn.setAttribute('style', sizeBtn.getAttribute("style"));
        obs.disconnect();
      }
    });
 
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"]
    });
 
    if (sizeBtnContainer) {
      sizeBtnContainer.prepend(sizeGuideBtn);
    }
 
    sizeGuideBtn.addEventListener('click', () => {
      popupContainer.querySelector('.size-tab-main button.active').click();
    });
 
    const aiSizeButtonCount = document.querySelectorAll('.ai-size-button')?.length || 0;
    const aiSizeGuideButtonCount = document.querySelectorAll('.ai-size-guide-button')?.length || 0;
 
    const sizeTab = document.createElement('div');
    sizeTab.className = 'size-tab-main';
    sizeTab.innerHTML = `
      <button class="btn-rec active">Size Recommendation</button>
      <button class="btn-chart">Size Chart</button>
      <span class="close-popup"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#683894"></circle><path d="M20.7564 9.25199C20.6792 9.17464 20.5875 9.11328 20.4865 9.07141C20.3856 9.02954 20.2774 9.00799 20.1681 9.00799C20.0589 9.00799 19.9507 9.02954 19.8497 9.07141C19.7488 9.11328 19.6571 9.17464 19.5799 9.25199L15.5 13.3236L11.4201 9.24364C11.3428 9.1664 11.2511 9.10513 11.1502 9.06332C11.0493 9.02152 10.9411 9 10.8319 9C10.7226 9 10.6144 9.02152 10.5135 9.06332C10.4126 9.10513 10.3209 9.1664 10.2436 9.24364C10.1664 9.32089 10.1051 9.41259 10.0633 9.51352C10.0215 9.61444 10 9.72262 10 9.83186C10 9.9411 10.0215 10.0493 10.0633 10.1502C10.1051 10.2511 10.1664 10.3428 10.2436 10.4201L14.3236 14.5L10.2436 18.5799C10.1664 18.6572 10.1051 18.7489 10.0633 18.8498C10.0215 18.9507 10 19.0589 10 19.1681C10 19.2774 10.0215 19.3856 10.0633 19.4865C10.1051 19.5874 10.1664 19.6791 10.2436 19.7564C10.3209 19.8336 10.4126 19.8949 10.5135 19.9367C10.6144 19.9785 10.7226 20 10.8319 20C10.9411 20 11.0493 19.9785 11.1502 19.9367C11.2511 19.8949 11.3428 19.8336 11.4201 19.7564L15.5 15.6764L19.5799 19.7564C19.6572 19.8336 19.7489 19.8949 19.8498 19.9367C19.9507 19.9785 20.0589 20 20.1681 20C20.2774 20 20.3856 19.9785 20.4865 19.9367C20.5874 19.8949 20.6791 19.8336 20.7564 19.7564C20.8336 19.6791 20.8949 19.5874 20.9367 19.4865C20.9785 19.3856 21 19.2774 21 19.1681C21 19.0589 20.9785 18.9507 20.9367 18.8498C20.8949 18.7489 20.8336 18.6572 20.7564 18.5799L16.6764 14.5L20.7564 10.4201C21.0734 10.103 21.0734 9.56904 20.7564 9.25199Z" fill="white"></path></svg></span>
    `;
 
    popupContainer.prepend(sizeTab);
 
    const btnRec = sizeTab.querySelector('.btn-rec');
    const btnChart = sizeTab.querySelector('.btn-chart');
 
    if (aiSizeButtonCount === 0) btnRec.style.display = "none";
    if (aiSizeGuideButtonCount === 0) btnChart.style.display = "none";
 
    const setActive = (activeBtn) => {
      [btnRec, btnChart].forEach(btn => btn.classList.remove('active'));
      activeBtn.classList.add('active');
    };
 
    btnRec.addEventListener('click', () => {
      setActive(btnRec);
      document.querySelector('.ai-size-button')?.click();
    });
 
    btnChart.addEventListener('click', () => {
      setActive(btnChart);
      document.querySelector('.ai-size-guide-button')?.click();
    });
 
   
    popupContainer.querySelector('.close-popup').addEventListener('click', () => {
      if(popupContainer.querySelector('.ai-size-popup-content:not(.ai-size-hidden)')){
        popupContainer.querySelector('.ai-size-popup-content .ai-size-popup-header .close').click();
      }
      if(popupContainer.querySelector('.ai-size-guide:not(.ai-size-hidden)')){
        popupContainer.querySelector('.ai-size-guide .ai-size-guide-header-container .close').click();
      }
    });
  }
}, 1000);
 
setTimeout(() => {
  clearInterval(intervalId);
}, 20000);